import { SelectOption } from '@frontend/basic-forms';
import { IoTEnumClient } from '@frontend/iot/api';
import { IoTBrand } from '@frontend/iot/types';
import { useEffect, useState } from 'react';

interface ViewProps {
    options: SelectOption<IoTBrand>[];
    isLoading: boolean;
}

export const useIoTBrandSelect = (): ViewProps => {
    const [options, setOptions] = useState<SelectOption<IoTBrand>[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);
        IoTEnumClient.fetchIoTBrands()
            .then((brands) => {
                setOptions(
                    brands.map((brand) => ({
                        value: brand as IoTBrand,
                        label: brand.replace(/_/g, ' ')
                    }))
                );
            })
            .finally(() => setIsLoading(false));
    }, []);

    return { options, isLoading };
};
